import PropTypes from 'prop-types';
import { Typography } from '@mui/material';
import React from 'react';

import { useTranslation } from 'react-i18next';

import { getBillStatusData } from '../services/utils/translations-constants.js';

const BillStatusLabel = ({ textAlign, title }) => {
  const { t } = useTranslation();
  const { billingStatusesMap } = getBillStatusData(t);
  let initialInputTitle = title;

  const BillStatusData = {
    PAID: { color: '#4caf50', name: 'paid' },
    UNPAID: { color: '#eb0f0f', name: 'unpaid' },
    NOT_APPLICABLE: { color: '#eb0f0f', name: 'not_applicable' },
    DISPUTE_CREATED: { color: '#eb0f0f', name: 'dispute_created' },
    DISPUTED: { color: '#eb0f0f', name: 'disputed' },
    GENERATED: { color: '#0c5ead', name: 'generated' },
    SENT: { color: '#eb880f', name: 'sent' },
  };

  function geti18status() {
    const translatedBillingStatuses =
      billingStatusesMap[initialInputTitle] || initialInputTitle;
    return translatedBillingStatuses;
  }

  return (
    <Typography
      align={textAlign}
      color={BillStatusData[initialInputTitle]?.color}
    >
      {geti18status()}
    </Typography>
  );
};

BillStatusLabel.propTypes = {
  title: PropTypes.string,
};
export default BillStatusLabel;
